type Task = () => Promise<void>;

class ThumbnailQueue {
  private concurrency: number;
  private delayMs: number;
  private running = 0;
  private queue: Task[] = [];
  private isPumping = false;

  constructor(concurrency = 3, delayMs = 200) {
    this.concurrency = concurrency;
    this.delayMs = delayMs;
  }

  enqueue(task: Task): () => void {
    let cancelled = false;
    const wrappedTask: Task = async () => {
      if (cancelled) return;
      await task();
    };

    this.queue.push(wrappedTask);
    this.pump();

    return () => {
      cancelled = true;
      const idx = this.queue.indexOf(wrappedTask);
      if (idx !== -1) {
        this.queue.splice(idx, 1);
      }
    };
  }

  private pump() {
    if (this.isPumping) return;
    this.isPumping = true;

    const step = () => {
      if (this.queue.length === 0) {
        this.isPumping = false;
        return;
      }

      if (this.running >= this.concurrency) {
        this.isPumping = false;
        return;
      }

      const nextTask = this.queue.shift();
      if (!nextTask) {
        this.isPumping = false;
        return;
      }

      this.running++;

      (async () => {
        try {
          await nextTask();
        } finally {
          this.running--;
          this.pump();
        }
      })();

      // Stagger next start by delayMs
      setTimeout(() => {
        this.isPumping = false;
        this.pump();
      }, this.delayMs);
    };

    step();
  }
}

export const thumbnailQueue = new ThumbnailQueue(3, 200);
